import API from '../../apis';
import { action, generateErrorAction } from '../actions';
import actionTypes from './actionTypes';

export const getSettings = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.settings
        .getSettings(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_SETTINGS_FAILED,
              reject: actionTypes.GET_SETTINGS_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_SETTINGS_LOADING);
  const success = res => action(actionTypes.GET_SETTINGS__SUCCESS, res);

  return request();
};

export const updateSettings = settingObject => {
  return dispatch => {
    dispatch(action(actionTypes.UPDATE_SETTINGS_LOADING));
    return API.settings
      .updateSettings(settingObject)
      .then(res => dispatch(action(actionTypes.UPDATE_SETTINGS_SUCCESS, res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.UPDATE_SETTINGS_FAILED,
            reject: actionTypes.UPDATE_SETTINGS_REJECT
          })
        );
        throw err;
      });
  };
};
